import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { View, Dimensions, ImageBackground, Platform } from 'react-native'
import { Button, Heading } from 'native-base'
import { RecentCard } from './RecentCard'
import { db, auth } from '../firebase'
import { collection, onSnapshot } from 'firebase/firestore'
import Carousel from 'react-native-reanimated-carousel'
import LottieView from 'lottie-react-native'
import { useNavigation } from '@react-navigation/native'
import { MaterialCommunityIcons } from '@expo/vector-icons'

const RecentlySubmittedContainer = styled(View)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    padding: 10px;
`

export const RecentlySubmitted = () => {
    const width = Dimensions.get('window').width
    const [claimedData, setClaimedData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const userID = auth.currentUser.uid
    const navigation = useNavigation()

    useEffect(() => {
        setIsLoading(true)
        const unsubscribe = onSnapshot(collection(db, 'homes'), (snapshot) => {
            snapshot.docs.forEach((doc) => {
                if (doc.data().tag_owner_ID === userID) {
                    setClaimedData((prev) => [...prev, doc.data()])
                }
            })
            setIsLoading(false)
        })
        return () => {
            unsubscribe()
        }
    }, [])

    return isLoading ? (
        <ImageBackground>{Platform.OS !== 'web' && <LottieView source={require('../assets/animations/loupe.json')} autoPlay loop style={{ width: '80%', alignSelf: 'center', marginTop: 20 }} />}</ImageBackground>
    ) : (
        <RecentlySubmittedContainer>
            <Heading style={{ fontSize: 16 }}>Your Recent Submissions</Heading>
            {claimedData.length > 0 ? (
                <Carousel
                    loop
                    autoPlay={claimedData.length <= 1 ? false : true}
                    autoPlayInterval={3000}
                    snapEnabled
                    width={width}
                    height={width / 2}
                    data={claimedData.slice(0, 5)}
                    renderItem={({ item }) => {
                        return <RecentCard home={item} />
                    }}
                    mode="parallax"
                    modeConfig={{
                        parallaxScrollingScale: 0.9,
                        parallaxScrollingOffset: 50,
                    }}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                />
            ) : (
                <View
                    style={{
                        backgroundColor: 'rgba(256, 256, 256, 0.8)',
                        padding: 20,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 5,
                        marginTop: 50,
                    }}
                >
                    <Heading style={{ fontSize: 16, textAlign: 'center' }}>You haven't submitted any homes yet!</Heading>
                    <Button
                        onPress={() => navigation.navigate('Submit')}
                        size="lg"
                        style={{
                            backgroundColor: '#6c387a',
                            borderRadius: 5,
                            alignItems: 'center',
                            marginTop: 20,
                        }}
                        leftIcon={<MaterialCommunityIcons name="map-marker" size={24} color="white" />}
                    >
                        Get started now!
                    </Button>
                </View>
            )}
        </RecentlySubmittedContainer>
    )
}
